// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gA_8_","viewAllIcon":"styles_viewAllIcon__id8GR","text":"styles_text__eHP_g","dark":"styles_dark__9wnXG"};